"use strict";
/**
 * Quick-and-dirty way to generate unique DOM-friendly ids on the fly...
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
exports.randomString = function (len) {
    var str = '';
    while (str.length < len) {
        str += exports.ALPHABET[Math.floor(Math.random() * exports.ALPHABET.length)];
    }
    return str;
};
//# sourceMappingURL=StringUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/StringUtils.js
// module id = 106
// module chunks = 35783957827783 127651196306611 162898551421021